<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off" method="post" :disabled="loading" data-vv-scope="form"
                @keyup.enter="() => {}"
                @submit.prevent="onBeforeSaveItem">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">{{ titleItem }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-active"
                                name="active"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.active"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('active') }]"
                                :error="fnFirstError('active')"
                                :helpText="`${pageID}.help.active`">
                                Ativo
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-private"
                                name="private"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.private"
                                :reduce="option => option.code"
                                v-validate="{required:form.layer_id!=null}"
                                :inputClasses="[{'is-invalid': fnHasError('private') }]"
                                :error="fnFirstError('private')"
                                :helpText="`${pageID}.help.private`">
                                Privado
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-order"
                                name="order"
                                v-model.trim="form.order"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid': fnHasError('order') }]"
                                :error="fnFirstError('order')"
                                :helpText="`${pageID}.help.order`">
                                Ordem
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-layer_id"
                                name="layer_id"
                                label="name"
                                :filterable="true"
                                :options="groups"
                                v-model.trim="form.layer_id"
                                :indentText="true"
                                indentationTarget="layer_id"
                                v-validate="{required: isLayer}"
                                :inputClasses="[{'is-invalid': fnHasError('layer_id') }]"
                                :error="fnFirstError('layer_id')"
                                :helpText="`${pageID}.help.group`">
                                Grupo
                            </MaterialSelect>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-if="!isLayer" class="col-sm-4">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-collapse"
                                name="collapse"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.collapse"
                                :reduce="option => option.code"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('collapse') }]"
                                :error="fnFirstError('collapse')" >
                                Collapsed
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="" :class="[isLayer ? 'col-sm-9' : 'col-sm-8']">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-name"
                                name="name"
                                v-model.trim="form.name"
                                v-validate="'required|min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                :error="fnFirstError('name')">
                                Nome
                            </MaterialInput>
                        </div>
                    </div>
                    <div  v-if="isLayer" class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-visible"
                                name="visible"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.visible"
                                :reduce="option => option.code"
                                v-validate="{required:form.layer_id!=null}"
                                :inputClasses="[{'is-invalid': fnHasError('visible') }]"
                                :error="fnFirstError('visible')"
                                :helpText="`${pageID}.help.visible`">
                                Visível
                            </MaterialSelect>
                        </div>
                    </div>
                </div>
                <div v-if="isLayer">
                    <!-- LEGEND -->
                    <div class="row">
                        <div class="col-12 col-sm mb-3 mb-sm-4 photos">
                            <div class="row">
                                <div class="col">
                                    <h6 class="font-weight-normal">Icon</h6>
                                    <hr class="mt-2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="photo icon">
                                        <upload-multiple-image
                                            :disabled="readonlyFormItem"
                                            name="icon_layer"
                                            ref="uploadIcon"
                                            v-model="icon_layer"
                                            :maxImage="1"
                                            :multiple="false"
                                            :noOverlay="true"
                                            :showImageLimitMessage="false"
                                            v-validate="''"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <h6 class="font-weight-normal mt-2">Copyrights</h6>
                                        <template v-if="readonlyFormItem">
                                            <div v-html="form.attribution"></div>
                                        </template>
                                        <template v-else>
                                            <div class="city-form-group" :class="{'is-invalid': fnHasError('attribution') }">
                                                <ckeditor
                                                    name="attribution"
                                                    v-model="form.attribution"
                                                    :disabled="readonlyFormItem"
                                                    :editor="cKEditor.editor"
                                                    :config="cKEditor.editorConfig"
                                                    v-validate="'min:3'">
                                                </ckeditor>
                                                <small v-if="fnFirstError('attribution')" class="d-block invalid-feedback">{{ fnFirstError('attribution') }}</small>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm mb-3 mb-sm-4 photos legend">
                            <div class="row">
                                <div class="col">
                                    <h6 class="font-weight-normal">Legenda</h6>
                                    <hr class="mt-2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-legend_automatic"
                                            name="legend_automatic"
                                            label="name"
                                            @input="onChangeLegendAutomatic"
                                            :filterable="true" :options="lists.onoff"
                                            :reduce="option => option.code"
                                            v-model.trim="form.legend_automatic"
                                            v-validate="''"
                                            :inputClasses="[{'is-invalid': fnHasError('legend_automatic') }]"
                                            :error="fnFirstError('legend_automatic')"
                                            :helpText="`${pageID}.help.legend_automatic`">
                                            Legenda automatica
                                        </MaterialSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!form.legend_automatic">
                                <div class="col-12 mb-3">
                                    <h6 class="font-weight-normal">Imagem</h6>
                                    <div class="photo legend">
                                        <upload-multiple-image
                                            :disabled="readonlyFormItem"
                                            name="legend_layer"
                                            imageSize="small"
                                            direction="horizontal"
                                            class=""
                                            v-model="legend_layer"
                                            :maxImage="1"
                                            :multiple="false"
                                            :noOverlay="true"
                                            :showImageLimitMessage="false"
                                            v-validate="''"
                                        >
                                        </upload-multiple-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- FEATURE INFO -->
                    <div v-if="form.feature_info">
                        <div class="row">
                            <div class="col">
                                <h6>Feature Info</h6>
                                <hr class="my-3"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg"
                                        id="input-queryable"
                                        name="queryable"
                                        label="name"
                                        :filterable="true"
                                        :options="lists.onoff"
                                        v-model.trim="form.feature_info.queryable"
                                        :reduce="option => option.code"
                                        v-validate="{required:form.layer_id!=null}"
                                        :inputClasses="[{'is-invalid': fnHasError('queryable') }]"
                                        :error="fnFirstError('queryable')" >
                                        Pesquisável
                                    </MaterialSelect>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyFormItem || !form.feature_info.queryable"
                                        class="city-form-group city-bg"
                                        id="input-queryable-format"
                                        name="queryable-format"
                                        label="name"
                                        :filterable="true"
                                        :options="lists.featureinfoformats"
                                        v-model.trim="form.feature_info.format"
                                        :reduce="option => option.code"
                                        v-validate="{required:form.feature_info.queryable}"
                                        :inputClasses="[{'is-invalid': fnHasError('queryable-format') }]"
                                        :error="fnFirstError('queryable-format')" >
                                        Formato
                                    </MaterialSelect>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- TEMA -->
                    <div>
                        <h6 class="mt-4">Temas (Layers)</h6>
                        <hr/>
                        <div class="row">
                            <div class="order-2 order-sm-1 col-12 col-sm-7 col-lg-6" v-if="!readonlyFormItem">
                                <table-data
                                    :showTitleData="false"
                                    ref="tblResources"
                                    tableWrapperClass="py-2 px-1"
                                    :startLoad="startLoadResources"
                                    :route="url.getResources"
                                    :settings="table.settings"
                                    :columns="table.columns"
                                    :inlineFilters="table.filters"
                                    :autoUpdateFilter="table.autoUpdateFilter"
                                    :externalFilters="tblFilters"
                                    :autoUpdateExternalFilter="table.autoUpdateExternalFilter"
                                    :addParamsToUrl="table.addParamsToUrl"
                                    :loadingMsg="table.loadingMsg"
                                    :notFoundMsg="table.notFoundMsg"
                                    :orderByTemplate="table.orderByTemplate"
                                    @error-load="showError"
                                >
                                    <template v-slot:filters="{ tableFilters, search }">
                                        <form autocomplete="false" @submit.prevent="search" @keyup.enter="search">
                                            <div class="row header">
                                                <div class="col-12">
                                                    <header-list :title="null" :placeholderSearch="searchPlaceholder" v-model="tableFilters.q" headerClass="mb-3"></header-list>
                                                </div>
                                            </div>
                                        </form>
                                    </template>

                                    <template v-slot:body="{row, index, remove}">
                                        <td :class="table.columns[0].class">
                                            <ResourceItemList
                                                :value="row"
                                                :enableCrossResource="enableCrossresources"
                                                :readonlyForm="readonlyFormItem"
                                                @addResource="addResource(row, index, remove)"
                                                @addCrossResource="addCrossResource(row, index)"
											/>
                                        </td>
                                    </template>
                                </table-data>
                            </div>
                            <div class="order-1 order-sm-2 col-12 col-sm-5 col-lg-6">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="d-flex justify-content-between justify-content-md-start align-items-center">
                                            <span class="text-muted pr-md-4">{{ help.resources_title }}</span>
                                            <span class="badge badge-secondary badge-pill">{{form.resources.length}}</span>
                                        </h5>
                                        <div class="form-group city-form-group">
                                            <help-span :helpText="help.resources_layers" v-if="!readonlyFormItem" />
                                            <small v-if="fnHasError('resources')" class="invalid-feedback d-block">{{ fnFirstError('resources') }}</small>
                                        </div>
                                        <draggable
                                            tag="div"
                                            v-model="form.resources"
                                            v-bind="dragOptions"
                                            draggable=".list-group-item"
                                            @start="onDragStart"
                                            @end="onDragEnd"
                                            name="resources"
                                            v-validate="{required: true, length: 1}"
                                        >
                                            <transition-group
                                                v-validate=""
                                                tag="ul"
                                                class="p-0"
                                                type="transition"
                                                :name="!drag ? 'flip-list' : null"
                                            >
                                                <li
                                                    class="list-group-item p-0 border-0 cursor-default"
                                                    v-for="(element, idx) in form.resources"
                                                    :key="element.id"
                                                >
                                                    <ResourceItemSelected
                                                        :value="element"
                                                        :readonlyForm="readonlyFormItem"
                                                        :pivotKey="pivotResources"
                                                        @removeResource="removeResource(idx)"
													/>
                                                </li>
                                            </transition-group>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialColorPicker
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-icon_bg_color"
                                name="icon_bg_color"
                                v-model.trim="form.icon_bg_color"
                                v-validate="{required:!form.layer_id}"
                                :inputClasses="[{'is-invalid': fnHasError('icon_bg_color') }]"
                                :error="fnFirstError('icon_bg_color')"
                                :helpText="`${pageID}.help.icon_bg_color`">
                                Côr
                            </MaterialColorPicker>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div class="form-group">
                            <MaterialInput
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-icon"
                                name="icon"
                                v-model.trim="form.icon"
                                v-validate="{required:!form.layer_id}"
                                :inputClasses="[{'is-invalid': fnHasError('icon') }]"
                                :error="fnFirstError('icon')"
                                :helpText="`${pageID}.help.icon`">
                                Icon
                            </MaterialInput>
                        </div>
                    </div>
                </div>

                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    @save="onBeforeSaveItem"
                    @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                >
            </buttons-footer>
        </form>

        </div>
    </div>
</template>

<script>
    import DetailsMixin from './mixins/DetailsMixin';
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';

    export default {
        name: 'LayerDetails',
        components: {
            ResourceItemList: () => import(/* webpackChunkName: "ogc-resourceitemlist" */ '@/app/shared/components/ogc/resource/ResourceItemList'),
            ResourceItemSelected: () => import(/* webpackChunkName: "ogc-resourceitemselected" */ '@/app/shared/components/ogc/resource/ResourceItemSelected'),
        },
        mixins: [
            DetailsMixin,
            CkEditorConfigMixin,
        ],
        data() {
            return {
                pageID: 'layers',
                pageTitle: 'Camadas',
                form: {
                    id: null,
                    behavior: null,
                    layer_id: null,
                    name: null,
                    filter: null,
                    collapse: true,
                    active: true,
                    visible: false,
                    private: false,
                    order: 1,
                    icon_bg_color: null,
                    icon: null,
                    legend_automatic: false,
                    icon_layer: [],
                    legend_layer: [],
                    feature_info: {
                        queryable: false,
                        format: 'TEXT',
                    },
                    resources: [],
                    attribution: '',
                },
                icon_layer: [],
                legend_layer: [],
                toolbarType: 'basic',
            }
        },
        computed: {

        },
        methods: {
            onChangeServerType() {
                if(!this.form.server_type_id){
                    this.form.ogc_internal = null;
                    this.form.ogc_internal_server_id = null;
                    this.form.url = null;
                    this.form.service_id = null;
                    this.form.service_version_id = null;
                    this.form.layers = null;
                    //this.resetValidator();
                }
            },
            onChangeOGCInternal() {
                if(this.form.ogc_internal==null){
                    this.form.ogc_internal_server_id = null;
                    this.form.service_id = null;
                    this.form.service_version_id = null;
                    this.form.layers = null;
                    //this.resetValidator();
                }
                this.form.url = this.form.ogc_internal ? null : this.form.url;
            },
            onChangeService() {
                if(!this.form.service_id){
                    this.form.layers = null;
                    //this.resetValidator();
                }
            },
            onChangeLegendAutomatic() {
                if(!this.form.legend_automatic){
                    this.legend_layer = [];
                }
            },
            onBeforeSaveItem() {
                if(!this.isLayer){
                    this.form.feature_info = null;
                }
                this.saveItem(`${this.moduleCode}.${this.pageID}`, ['icon_layer', 'legend_layer']);
            },
            forceDirtyUpload: function(key){
                if(this.fields.$form && this.fields.$form[key]){
                    this.fields.$form[key].dirty=true;
                }
            },
        },
        watch:{
            'icon_layer': {
                handler(value, oldValue){
                    this.forceDirtyUpload('icon_layer');
                },
                deep: true,
            },
            'legend_layer': {
                handler(value, oldValue){
                    this.forceDirtyUpload('legend_layer');
                },
                deep: true,
            },
        }

    }
</script>

<style scoped lang="scss">
    @import "@styles/_mixins.scss";
    .photos {
        .photo {
            height: 100%;
            min-height: 100px;
            max-width: 100%;

            @include sm {
                min-height: 150px;
            }
            &.icon {
                // min-height: 50px;
                // max-height: 100px;
            }
        }
    }

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>

<style lang="scss">
    .ck-editor .ck-content.ck-editor__editable {
        min-height: 150px;
    }
</style>
